import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../../@types';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { getResponsivePlacementCardStyles } from '../../styles';

const MMAPlacementCardImpl = ({
  isEnabled,
  url,
  children,
  mmaPlacementCardClassName,
  classes,
}: UAPPlacementComponentProps) =>
  //
  (
    <div className={classnames(classes.mmaPlacementCardRoot, !isEnabled && classes.mmaPlacementCardDisabled, mmaPlacementCardClassName, 'ad-placement-card-preview')}>
      <div className="card-parent">
        {url && (
        <a
          className="placement-card-content"
          target="_blank"
          rel="noopener noreferrer"
          href={url}
        >
          {children}
        </a>
        )}
        {!url && (
        <div
          className="placement-card-content"
        >
          {children}
        </div>
        )}
      </div>
    </div>
  );
MMAPlacementCardImpl.propTypes = {
  isEnabled: PropTypes.bool,
  url: PropTypes.string,
  children: PropTypes.node.isRequired,
  mmaPlacementCardClassName: PropTypes.string,
  classes: PropTypes.shape({
    mmaPlacementCardRoot: PropTypes.string,
    mmaPlacementCardDisabled: PropTypes.string,
  }).isRequired,
};

MMAPlacementCardImpl.defaultProps = {
  isEnabled: true,
  url: undefined,
  mmaPlacementCardClassName: undefined,
};

export const ResponsiveMMAPlacementCard = withUAPLThemedStyles(
  MMAPlacementCardImpl,
  getResponsivePlacementCardStyles,
  { componentName: 'MMAPlacementCard ' }
);
